export default __webpack_public_path__ + "static/media/killhouse.4eb2dcdf.jpg";